export default class CounterPolicy {
    static browse(user) {
        return user.hasPermissionTo('browse:counters');
    }

    /* eslint-disable-next-line no-unused-vars */
    static edit(user, counter) {
        return user.hasPermissionTo('edit:counters');
    }

    static add(user) {
        return user.hasPermissionTo('add:counters');
    }

    static destroy(user, counter) {
        return counter.documents_count === 0
            && user.hasPermissionTo('delete:counters');
    }

    /* eslint-disable-next-line no-unused-vars */
    static sort(user, counter) {
        return user.hasPermissionTo('edit:counters');
    }

    static updateSortIndex(user, counter, destination) {
        if (!CounterPolicy.sort(user, counter)) {
            return false;
        }

        if (!destination) {
            return false;
        }

        return counter.sort_index !== Number(destination);
    }
}
